var path = 'src/app/forms/help.html';
var html = "<span class=help-block ng-transclude></span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/help.html
 ** module id = 326
 ** module chunks = 0
 **/